// Reemplaza (o agrega) el mensaje pre-cargado (?text=) de un enlace de
// WhatsApp, conservando intacto el resto de la URL — especialmente el
// número (phone=+51...), que varía por proyecto.
const AgregarMensajeWhatsapp = (url, mensaje) => {
  if (!url || !mensaje) return url

  const encoded = encodeURIComponent(mensaje)

  // Si ya existe un parámetro text, se reemplaza su valor.
  if (/[?&]text=/.test(url)) {
    return url.replace(/([?&]text=)[^&]*/, `$1${encoded}`)
  }

  // Si no existe, se agrega respetando si la URL ya tiene query string.
  const separador = url.includes("?") ? "&" : "?"
  return `${url}${separador}text=${encoded}`
}

export default AgregarMensajeWhatsapp
